import React, {Component} from "react";
import {connect} from "react-redux";
import {Layer, Line} from "react-konva";
import {
    emitLineLenght,
    endToolMeasuring,
    mouseClickMeasure,
    resetToolMeasurement,
    startToolMeasuring
} from "../../actions/measuretool-actions";
import {GLOBAL_PROJECT_TYPE_CHAMBER} from "../../lib/types";
import {measureToolEditSwitch} from "../../actions/drawingtoolbar-actions";


class MeasureLength extends Component {
    state = {
        measuring: false,
        mouseClickMeasure: false,
        step: 0
    };

    componentDidMount() {
        /* get stage and layer references */
        let stage = this.lineNode.getStage();
        stage.on("click.measuretool", this.handleMouseClick.bind(this));
        stage.on("mousemove.measuretool", this.handleMouseLockedMove.bind(this));
    }

    componentDidUpdate( prevProps, prevState, snapshot ) {
        if (
            prevProps.active !== this.props.active &&
            prevProps.points !== this.props.points &&
            this.props.points.length === 0
        ) {
            this.setState({
                measuring: false,
                mouseClickMeasure: false,
                step: 0
            });
        }
    }

    /**
     * Engages the mouse click and locks or unlocks the mouse
     */
    handleMouseClick() {
        if (!this.state.mouseClickMeasure && this.props.active) {
            // first click starts mouse lock
            this.handleMouseLock();
            this.setState({mouseClickMeasure: true});
            this.setState({step: 1});
            this.props.mouseClickMeasure(true);
        } else if (this.state.mouseClickMeasure && this.props.active) {
            if (this.state.step === 1) {
                // second click ends mouse lock
                this.handleMouseUnlock();
                this.setState({step: 2});
            } else if (this.state.step === 2) {
                // third click resets measure ruler
                this.setState({step: 3});
                this.setState({mouseClickMeasure: false});
                this.props.mouseClickMeasure(false);
                this.props.measureToolEditSwitch(this.props.measureToolEdit);
            }
        }
    }

    /**
     * Handles mouse locking when ruler draw is enabled
     */
    handleMouseLock() {
        if (this.props.active) {
            let layer = this.lineNode.getLayer();
            const mousePosition = this.getMousePosition();

            /* trigger the start measure action */
            this.props.startToolMeasuring(mousePosition.x, mousePosition.y);
            /* the the measuring state */
            this.setState({measuring: true});
            /* do batch draw */
            layer.batchDraw();
        }
    }

    /**
     * Draws the ruler main line while the mouse is locked
     */
    handleMouseLockedMove() {
        if (this.state.measuring && this.props.active) {
            let layer = this.lineNode.getLayer();
            const mousePosition = this.getMousePosition();

            /* set temporary second point while drawing */
            let points = this.lineNode.points();
            /* remove last two coordinates and push new ones */
            points.splice(2, 2, mousePosition.x, mousePosition.y);
            /* add points to line */
            this.lineNode.points(points);
            /* do batch draw */
            layer.batchDraw();
        }
    }

    /**
     * Handles mouse unlocking when ruler has being drawn, and it stopped by a second click
     */
    handleMouseUnlock() {
        if (this.props.active) {
            let layer = this.lineNode.getLayer();
            let mousePosition = this.getMousePosition();

            /* get current points */
            let points = this.lineNode.points();
            /* calculate line length */
            let pixels = Math.sqrt(
                Math.pow(mousePosition.x - points[0], 2)
                + Math.pow(mousePosition.y - points[1], 2),
            ) + 1;

            this.props.emitLineLenght(Number(pixels.toFixed(2)));
            this.props.endToolMeasuring(mousePosition.x, mousePosition.y);

            /* reset measurement mechanism */
            this.props.resetToolMeasurement();

            /* the the measuring state */
            this.setState({ measuring: false });

            /* do batch draw */
            layer.batchDraw();
        }
    }

    /**
     * Returns position calculation
     * @returns {{x: number, y: number}}
     */
    getMousePosition() {
        const {viewportScaleX: scaleX, viewportScaleY: scaleY} = this.props;
        let stage = this.props.stageNode.getStage();
        return {
            x: stage.getPointerPosition().x / scaleX - stage.x() / scaleX,
            y: stage.getPointerPosition().y / scaleY - stage.y() / scaleY
        };
    }

    /**
     * Handles React Render
     * @returns {JSX.Element}
     */
    render() {
        return (
            <Layer>
                <Line
                    visible={this.props.active}
                    points={this.props.points}
                    stroke="green"
                    strokeWidth={2}
                    lineCap="round"
                    lineJoin="round"
                    dash={[5, 5]}
                    ref={node => {
                        this.lineNode = node;
                    }}
                />
            </Layer>
        );
    }
}

const mapStateToProps = state => {

    const projectType = state.globals.projectType;
    let viewportScaleX, viewportScaleY;

    if (projectType === GLOBAL_PROJECT_TYPE_CHAMBER) {
        viewportScaleX = state.viewport.scaleX;
        viewportScaleY = state.viewport.scaleY;
    } else {
        viewportScaleX = state.viewport.scaleXPipes;
        viewportScaleY = state.viewport.scaleXPipes;
    }

    return {
        stageNode: window.konvaStage,
        active: state.measuretool.active,
        points: state.measuretool.points,
        scaleValue: state.globals.scaleValue,
        viewportScaleX: viewportScaleX,
        viewportScaleY: viewportScaleY,
        measureToolEdit: state.drawingToolbar.measureToolEdit,
    };
};

const mapDispatchToProps = {
    startToolMeasuring,
    endToolMeasuring,
    emitLineLenght,
    resetToolMeasurement,
    mouseClickMeasure,
    measureToolEditSwitch,
};

/* export this contained component */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MeasureLength);



// WEBPACK FOOTER //
// ./src/components/Drawings/measure-length.js